<template>
  <div class="unm__outer the-welcome intro__stage">
    <div class="unm__container">
      <div class="welcome__container">
        <h1 class="heading-main">
          <template v-if="name">
            Hey
            <strong>{{ name }},</strong>
          </template>
          <strong v-else>Hey,</strong>
        </h1>
        <h2 class="impact-heading">Are You Lobo Ready?</h2>
        <button
          class="action-button action-button__white cta-large"
          @click="setStage('intro')"
        >Find Out</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    name: 'TheWelcome',
    computed: mapState(['name', 'stage', 'activeQuestion']),
    mounted() {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'Page Load',
        stage: this.stage,
        activeQuestion: this.activeQuestion,
      });
    },
    methods: mapMutations(['setStage']),
  };
</script>

<style lang="scss">

.welcome__overlay {
    background-color: $cherry;
}

.welcome__container {
    @include flex-grid-column(12);
    text-align: center;

    @include breakpoint(medium) {
        @include flex-grid-column(8);
        @include grid-column-offset(2);
    }
}

.the-welcome {
  &.v-enter,
  &.v-leave-to {
    opacity: 0;
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }

  &.v-enter-active,
  &.v-leave-active {
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheWelcome.vue